/**
 * Coorte da fase 2 da telemetria do funil (~4% da base = 525 restaurantes).
 *
 * GERADO a partir da réplica de produção multipedidos-rr em 2026-07-18 por seleção
 * estratificada (raras 100% + minorias com piso + top-up por volume). Cobre os eixos
 * de config (layout, fluxo de endereço, frete, pagamento, canais, país, volume), as 44
 * lojas de pizza LEGADO (new_nep_pizzas=0) e a camada de anomalias / config migrada pela
 * metade. O gerador, o CSV com atributos e o relatório de anomalias vivem no repo da stack
 * SAM (aws-sam-order-flow-monitor/cohort/). NÃO editar à mão — regerar pelo script.
 */
export const ORDER_FLOW_COHORT_IDS: number[] = [
  9, 14, 22, 38, 49, 77, 90, 98, 123, 137, 150, 203, 253, 268, 285, 320,
  332, 362, 376, 429, 460, 487, 489, 507, 627, 633, 646, 648, 676, 706, 723, 724,
  732, 738, 784, 798, 822, 867, 873, 891, 929, 991, 1015, 1076, 1149, 1152, 1261, 1301,
  1329, 1345, 1346, 1363, 1410, 1427, 1499, 1507, 1521, 1584, 1604, 1668, 1719, 1724, 1734, 1750,
  1839, 1851, 1853, 1857, 1873, 1880, 1916, 1994, 2030, 2073, 2083, 2143, 2175, 2179, 2252, 2253,
  2265, 2293, 2295, 2303, 2420, 2426, 2451, 2480, 2492, 2518, 2558, 2581, 2584, 2646, 2697, 2706,
  2725, 2731, 2751, 2753, 2808, 2898, 2910, 2947, 2982, 3002, 3012, 3096, 3140, 3197, 3240, 3272,
  3304, 3399, 3403, 3416, 3541, 3550, 3567, 3627, 3641, 3658, 3660, 3670, 3703, 3750, 3751, 3752,
  3777, 3823, 3837, 3845, 3855, 3863, 3945, 3967, 3975, 3989, 4017, 4074, 4077, 4117, 4163, 4182,
  4198, 4214, 4229, 4244, 4252, 4258, 4262, 4270, 4317, 4344, 4361, 4396, 4418, 4503, 4514, 4516,
  4550, 4560, 4597, 4639, 4650, 4666, 4768, 4850, 4884, 4909, 4921, 4922, 4929, 4960, 4983, 4988,
  5012, 5207, 5231, 5595, 5596, 5606, 5628, 5650, 5666, 5742, 5787, 5812, 5816, 5978, 6034, 6045,
  6072, 6092, 6101, 6118, 6145, 6159, 6166, 6201, 6216, 6224, 6228, 6236, 6244, 6317, 6319, 6326,
  6329, 6331, 6347, 6446, 6447, 6459, 6473, 6514, 6520, 6548, 6591, 6654, 6696, 6768, 6793, 6805,
  6831, 6848, 6880, 6904, 6913, 6920, 6955, 6969, 7017, 7021, 7082, 7121, 7148, 7193, 7247, 7249,
  7250, 7317, 7321, 7323, 7351, 7363, 7369, 7379, 7386, 7419, 7530, 7549, 7553, 7565, 7569, 7631,
  7636, 7657, 7697, 7738, 7750, 7755, 7758, 7794, 7812, 7916, 7940, 7954, 7956, 7985, 7990, 8015,
  8025, 8149, 8199, 8271, 8312, 8327, 8364, 8377, 8391, 8392, 8400, 8401, 8463, 8464, 8466, 8487,
  8603, 8610, 8641, 8672, 8674, 8685, 8709, 8735, 8737, 8752, 8820, 8854, 8855, 8884, 8899, 8932,
  8976, 8978, 8990, 9024, 9073, 9150, 9153, 9187, 9198, 9218, 9256, 9261, 9312, 9334, 9399, 9402,
  9425, 9437, 9468, 9497, 9528, 9543, 9609, 9674, 9747, 9844, 9845, 9959, 9968, 9993, 10004, 10019,
  10069, 10076, 10082, 10089, 10107, 10179, 10183, 10192, 10195, 10209, 10220, 10238, 10266, 10275, 10306, 10320,
  10338, 10371, 10376, 10397, 10398, 10432, 10480, 10483, 10524, 10532, 10545, 10574, 10612, 10621, 10696, 10714,
  10717, 10741, 10769, 10780, 10835, 11078, 11090, 11098, 11102, 11117, 11171, 11198, 11245, 11268, 11269, 11278,
  11290, 11297, 11322, 11326, 11330, 11339, 11343, 11351, 11366, 11379, 11387, 11395, 11406, 11429, 11430, 11446,
  11487, 11605, 11655, 11673, 11685, 11701, 11702, 11706, 11727, 11733, 11763, 11767, 11808, 11817, 11845, 11877,
  11893, 11899, 11900, 11960, 11970, 12017, 12022, 12043, 12044, 12052, 12067, 12073, 12088, 12117, 12186, 12221,
  12266, 12284, 12295, 12386, 12399, 12404, 12451, 12454, 12506, 12553, 12564, 12566, 12573, 12577, 12580, 12587,
  12602, 12608, 12609, 12611, 12614, 12638, 12666, 12676, 12685, 12690, 12692, 12693, 12694, 12700, 12727, 12747,
  12756, 12758, 12763, 12764, 12782, 12789, 12804, 12818, 12823, 12837, 12861, 12873, 12895, 12898, 13109, 13121,
  13154, 13159, 13176, 13177, 13188, 13199, 13208, 13216, 13256, 13302, 13395, 13427, 13428, 13434, 13448, 13468,
  13477, 13492, 13535, 13574, 13604, 13607, 13610, 13616, 13630, 13642, 13698, 13773, 13786, 13801, 13842, 13850,
  13867, 13906, 13924, 13925, 13929, 13937, 13970, 14009, 14013, 14046, 14049, 14051, 14059,
];

/**
 * Lojas na coorte por INCIDENTE ABERTO — fora da seleção estratificada.
 *
 * Diferente de `ORDER_FLOW_COHORT_IDS` (gerado, não editar à mão), esta lista é
 * escrita à mão, é pequena e é TEMPORÁRIA: cada entrada existe para dar potência
 * a uma medição específica, e sai quando a medição fecha.
 *
 * Por que é necessária: fora da curadoria só entram 10% dos devices. Numa loja de
 * ~27 pedidos/dia isso rende ~2,7 eventos — e no dia 17/08 rendeu ZERO. Medir
 * "o erro sumiu" com esse instrumento é medir o próprio ruído: zero na saída não
 * distingue correção de ausência de amostra. Ver a nota sobre potência em
 * CHECKOUT-REJEICOES.md.
 */
export const ORDER_FLOW_INCIDENT_IDS: number[] = [
  2868,  // MP-539 — ISADORA PIZZARIA, a loja que reclamou 3x; 0% de cobertura no dia 17
  8605,  // MP-539 — PIZZARIA VITÓRIA, mesma recusa, também fora da curadoria
  2605,  // CHECKOUT-REJEICOES nº 1 e 2 — PIZZAS DO 25, para acompanhar a cura de 15/08
];
